import { Injectable } from "@angular/core";
import { SystemMonitorLookupService } from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { PromiseSet, PrimaryPromiseSet } from "shared/cubiq-services";
import { GoldenLayoutServiceProfileConfig } from "../golden-layout/golden-layout-component";

@Injectable()
export class BfxConnectionMonitorService {
  protected primed: PromiseSet<boolean> = new PrimaryPromiseSet<boolean>();

  constructor(protected systemMonitorService: SystemMonitorLookupService) {
    this.systemMonitorService.isPrimed().then(
      (value: boolean) => {
        this.primed.resolve(true);
      },
      (err) => {
        this.primed.reject(err);
      },
    );
  }

  public isPrimed() {
    return this.primed.get();
  }
}
